<template>
  <tbody>
  <tr>
    <th>Soort</th>
    <td>{{ valuationTypeDescription }}</td>
    <th>Waarde</th>
    <td>{{ valuation.value | toCurrency }}</td>
  </tr>
  <tr>
    <th>Registratiedatum</th>
    <td>{{ valuation.registration_date | toDate }}</td>
  </tr>
  </tbody>
</template>
<script>

export default {
  name: "PropertyValuationShowComponent",
  components: {},
  props: {
    valuation: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      valuationTypes: {
        market_value: 'Marktwaarde',
        real_estate_value: 'WOZ waarde',
      }
    };
  },
  mounted() {
  },
  computed: {
    valuationTypeDescription() {
      return this.valuationTypes[this.valuation.type]
          ? this.valuationTypes[this.valuation.type]
          : '';
    }
  },
  methods: {}
}
</script>
<style scoped>
tbody {
  border-top: none !important;
}
</style>
